import { createStore } from 'vuex'
import { __LS_BUILDING__ } from '@/configs/constants'
import { __ls__, __f_data__ } from '@/includes/helper'

import { apiStore } from './apiStore'
import { authStore } from './auth.store.js'
import { checksStore } from './modules/checks.store'
import { navigationStore } from './modules/navigation.store'

export default createStore({
  state: {
    loading: false,
    local: null,
    languageHeaders: {},
    buildings: null,
    building: __ls__(__LS_BUILDING__) || null,
    enableHomeSvcCalls: 0,
    showCheckList: false,
    offers: [],
    vaadMenuItems: [],
    services: [],
    previousPath: '',
    HokFiledChangeCard: false,
    generalErrorToast: false,
    generalSuccessOrFailedModal: {
      visible: false,
    },
    curBID: null,
    apartmentSelected: null,
    financialReportMode: 'list',
    primevueLocale: null,
    beforeinstallpromptEvent: null,
    financialReportContact: null,
  },
  mutations: {
    setPreviousPath: (state, payload) => (state.previousPath = payload),
    setLanguageHeaders: (state, payload) => (state.languageHeaders = payload),
    setLoading: (state, payload) => (state.loading = payload),
    setLocal: (state, payload) => (state.local = payload),
    setBuilding: (state, payload) => (state.building = payload),
    setBuildings: (state, payload) => (state.buildings = payload),
    setEnableHomeSvcCalls: (state, payload) =>
      (state.enableHomeSvcCalls = payload),
    setShowCheckList: (state, payload) => (state.showCheckList = payload),
    setFinancialReportMode: (state, payload) =>
      (state.financialReportMode = payload),
    setOffers: (state, payload) => (state.offers = payload),
    setVaadMenuItems: (state, payload) => (state.vaadMenuItems = payload),
    setServices: (state, payload) => (state.services = payload),
    setHokFiledChangeCard: (state, payload) =>
      (state.HokFiledChangeCard = payload),
    setGeneralErrorToast: (state, payload) =>
      (state.generalErrorToast = payload),
    setGeneralSuccessOrFailedModal: (state, payload) =>
      (state.generalSuccessOrFailedModal = payload),
    setBuildingsBID: (state, payload) => (state.curBID = payload),
    setApartmentSelected: (state, payload) => (state.apartmentSelected = payload),
    setPrimevueLocale: (state, payload) => (state.primevueLocale = payload),
    SetBeforeinstallpromptEvent: (state, payload) =>
      (state.beforeinstallpromptEvent = payload),
    setFinancialReportContact: (state, payload) => {
      console.log('Setting financial report contact:', payload);
      state.financialReportContact = payload;
    },  },
  getters: {
    getPreviousPath: (state) => state.previousPath,
    getLanguageHeaders: (state) => state.languageHeaders,

    getLoading: (state) => state.loading,
    getLocal: (state) =>
      state.local ? state.local : { code: 'en', dir: 'ltr' },
    getServices: (state) => state.services,
    getService: (state) => (GroupID) => __f_data__(state.services, { GroupID }),
    getFinancialReportContact: (state) => state.financialReportContact,
  },
  actions: {
    async doLoading({ commit, getters }, payload) {
      commit('setLoading', payload)
      return new Promise((resolve) => resolve(getters.getLoading))
    },
    doLanguageHeaders({ commit, dispatch }, payload) {
      commit('setLanguageHeaders', payload)
      dispatch('doLocalization')
    },
    doLanguageSwitch({ commit, dispatch }, payload) {
      commit('setLocal', payload)
      dispatch('doLocalization')
    },
    doLocalization({ getters }) {
      const { code, dir } = getters.getLocal

      document.body.setAttribute('class', code)
      document.documentElement.setAttribute('class', code)

      document.body.setAttribute('dir', dir)
      document.documentElement.setAttribute('dir', dir)

      document.documentElement.setAttribute('lang', code)
    },
  },
  modules: {
    api: apiStore,
    authStore,
    checksStore,
    navigationStore,
  },
})
